import BootstrapTooltips from '../vendor/BootstrapTooltips';
import SweetAlert from '../vendor/SweetAlert';
import GLightBox from '../vendor/GLightBox';
import TomSelectSelector from '../vendor/TomSelectSelector';
import '../vendor/LivewireSortable';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';

// Scripts that will be used globally on both front and admin panel.

// Vendor
BootstrapTooltips.init();
SweetAlert.init();
GLightBox.init();
TomSelectSelector.init();
